import { FEATURE_FLAGS } from '~/constants';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';

import { useSavedListsStore } from '../../store';
import { ShareRosterModal } from '../ShareRosterModal';

export const ShareRosterListBtn = () => {
  const savedListRosterFlag = useFeatureFlag(
    FEATURE_FLAGS.foamSavedListsRoster,
  );

  const { creators } = useSavedListsStore();

  if (savedListRosterFlag === 'disabled') {
    if (creators.length) return null;
    return <ShareRosterModal />; // Share a roster button (this component is named incorrectly)
  }

  return null;
};
